import { Component } from '@angular/core';
import { TabComponent } from './tab/tab.component';

@Component({
    selector: 'qms-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['tabs.component.css']
})
export class TabsComponent {
    public tabs: TabComponent[];

    constructor() {
        this.tabs = [];
    }

    public addTab(tab: TabComponent) {
        if (this.tabs.length === 0) {
            tab.active = true;
        }
        this.tabs.push(tab);
    }

    public selectTab(selectedTab: TabComponent) {
        this.tabs.forEach((tab) => {
            tab.active = false;
        });
        selectedTab.active = true;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/generic/tabs/tabs.component.ts